import React from 'react';
import { ListingCardsCarouselSection } from '../../../containers/ListingPage/Sections';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { useListingsWithDistance } from '../../../hooks/useListingsWithDistance';
import { useCurrentUserLocation } from '../../../hooks/useCurrentUserLocation';
import { useSimilarLocationListingsRequest } from '../../../containers/ListingPage/useSimilarLocationListingsRequest';
import { useSelector } from 'react-redux';
import config from '../../../config';

const { userTypeHorseowner, minMatchingRate } = config;

const filterByRiderListing = (l, riderListingId) => l?.id?.uuid !== riderListingId;
const filterByCurrentAuthor = (l, user) =>
    l.attributes.publicData.type !== 'listing-rider' ||
    l?.relationships?.author?.data?.id?.uuid !== user?.id?.uuid;

const NearbyListingsSection = ({ scoreData, isLoggedOut, user, currentUser, riderListingId }) => {
    const [, , , viewport] = useIsMobile(1024);

    const similarLocationListings = useSelector(s =>
        (s.ListingPage?.similarLocationListings || []).filter(
            l => filterByCurrentAuthor(l, user) && filterByRiderListing(l, riderListingId)
        )
    );
    const userLocationData = useCurrentUserLocation({ user });

    const { userType: currentUserType, mainHorseId } = currentUser.attributes.profile.publicData;
    const currentUserIsOwner = currentUserType === userTypeHorseowner;

    const userOrigin = userLocationData?.origin || {};
    const userOriginStr = [userOrigin.lat, userOrigin.lng].filter(s => !!s).join(',');

    useSimilarLocationListingsRequest(userOriginStr, { pub_type: 'listing-rider' });

    /** useEffect */
    const listingsWithDistance = useListingsWithDistance(similarLocationListings, userOriginStr);

    /**
     * here we treat main horse as if it is a rider listing
     */
    const pseudoListing = currentUserIsOwner
        ? {
              id: {
                  uuid: mainHorseId,
              },
          }
        : null;

    return (
        <section>
            <ListingCardsCarouselSection
                viewport={viewport}
                scoreData={scoreData}
                listings={listingsWithDistance}
                riderListing={pseudoListing}
                minMatchingRate={minMatchingRate}
                isLoggedIn={!isLoggedOut}
                hideButtonsOnEndStart
                matchRiderListing={false}
            />
        </section>
    );
};

export default NearbyListingsSection;
